
import { secureStorage, StorageKeys } from "@services/secureStorage.service";
import { baseApi } from "@store/apis";

import type { BadgeDetails, BadgeDetailsRequest } from "./models";

const GetBadgeDetailsQuery = baseApi.injectEndpoints({

  endpoints: builder => ({
    GetBadgeDetails: builder.query({
      query: ({ challengeId }: BadgeDetailsRequest) => ({
        url: "GetBadgeDetailsById",
        method: "POST",
        body: {
          userId: secureStorage.get<string>(StorageKeys.USER_ID) || "",
          challengeId,
        },
      }),
      providesTags: ["Challenges"],
      transformResponse: (response: BadgeDetails) => response.result,
    }),
  }),
});

export const { useGetBadgeDetailsQuery } = GetBadgeDetailsQuery;
